let tl;
const updateCenterScroller = () => {
    if ($(window).width() >= 992) {
        if (!tl) {
            tl = gsap.timeline({
                scrollTrigger: {
                    trigger: $('.center-scrolled'),
                    scrub: true,
                    pin: '.center-scrolled>div',
                    pinSpacing: false,
                    //markers: true,
                    start: "top 50px",
                    end: 'center top',
                }
            });
        }
    }
    else if (tl) {
        tl.scrollTrigger.kill();
        tl = null;
    }
    if (tl) {
        tl.scrollTrigger.refresh();
    }
};
const resizeImages = () => {
    if ($(window).width() < 768) {
        $('.fluid-image-text').css('left', '');
        $('.fluid-image-right .img-container, .fluid-image-left .img-container').css('max-width', '');
        return;
    }
    $('.fluid-image').each(function (i, item) {
        const size_l = $('.container-size>.row>div:first-child', $(item)).outerWidth();
        const size_s = $('.container-size>.row>div:last-child', $(item)).outerWidth();
        const size = $(item).data('size');
        const maxWidth = Math.floor(($(window).width() - $('.container').outerWidth() - 30) / 2 + size_l);
        $('.img-container', $(item)).css('max-width', maxWidth);
        $('.fluid-image-text', $(item)).width(size_s - 30);
        if ($(item).hasClass('fluid-image-right')) {
            $('.fluid-image-text', $(item)).offset({ left: $('.container').offset().left });
        }
        else if ($(item).hasClass('fluid-image-left')) {
            $('.fluid-image-text', $(item)).offset({ left: $('.container-size>.row>div:last-child', $(item)).offset().left });
        }
    });
};
const reqizeCharts = () => {
    if ($(window).width() < 768) {
        $('.financial-highlights-chart-img').css('width', '100%');
        return;
    }
    setTimeout(() => {
        $('.financial-highlights-chart').each(function (i, item) {
            const textSize = $('.financial-highlights-chart-text', $(item)).outerWidth() - 30;
            const containerSize = $('.container').outerWidth() - 30;
            const imgWidth = Math.floor(containerSize - textSize - 40);
            $('.financial-highlights-chart-img', $(item)).width(imgWidth);
        });
    }, 300);
};
$(document).ready(() => {
    $(window).resize(resizeImages);
    resizeImages();
    $(window).resize(reqizeCharts);
    reqizeCharts();
    $(window).resize(function () {
        updateCenterScroller();
    });
    updateCenterScroller();
});
//# sourceMappingURL=internal.js.map